<div class="container-fluid">
  <div class="header">
    <h2>Cadastro de Tabela de Preços</h2>
    <p class="text-muted">Gerencie as tabelas de preços dos fornecedores</p>
  </div>

  <!-- Formulário -->
  <div class="form-container mb-4">
    <form [formGroup]="formTabelaPreco" (ngSubmit)="onSubmit()" class="tabela-preco-form">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="fornecedor">Fornecedor:</label>
            <select 
              id="fornecedor" 
              class="form-control" 
              formControlName="fornecedor">
              <option value="">Selecione o fornecedor</option>
              <option *ngFor="let fornecedor of fornecedores" [ngValue]="fornecedor.id">
                {{ fornecedor.text }}
              </option>
            </select>
            <small class="text-danger" *ngIf="isFieldInvalid('fornecedor')">
              {{ getFieldError('fornecedor') }}
            </small>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="microservico">Microserviço:</label>
            <select 
              id="microservico" 
              class="form-control" 
              formControlName="microservico">
              <option value="">Selecione o microserviço</option>
              <option *ngFor="let microservico of microservicos" [ngValue]="microservico.id">
                {{ microservico.text }}
              </option>
            </select>
            <small class="text-danger" *ngIf="isFieldInvalid('microservico')">
              {{ getFieldError('microservico') }}
            </small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="valor">Valor (R$):</label>
            <input 
              type="number" 
              id="valor" 
              class="form-control" 
              formControlName="valor"
              step="0.01"
              min="0.01"
              placeholder="0,00">
            <small class="text-danger" *ngIf="isFieldInvalid('valor')">
              {{ getFieldError('valor') }}
            </small>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="vigenciaInicio">Vigência Início:</label>
            <input 
              type="date" 
              id="vigenciaInicio" 
              class="form-control" 
              formControlName="vigenciaInicio">
            <small class="text-danger" *ngIf="isFieldInvalid('vigenciaInicio')">
              {{ getFieldError('vigenciaInicio') }}
            </small>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="vigenciaFim">Vigência Fim:</label>
            <input 
              type="date" 
              id="vigenciaFim" 
              class="form-control" 
              formControlName="vigenciaFim">
            <small class="text-danger" *ngIf="isFieldInvalid('vigenciaFim')">
              {{ getFieldError('vigenciaFim') }}
            </small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="observacao">Observação:</label>
            <textarea 
              id="observacao" 
              class="form-control" 
              formControlName="observacao"
              rows="3"
              placeholder="Observações sobre a tabela de preço"></textarea>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="limparFormulario()">
          <i class="fa fa-times"></i> Limpar
        </button>
        <button 
          type="submit" 
          class="btn btn-primary" 
          [disabled]="formTabelaPreco.invalid || loading">
          <i class="fa fa-save"></i> Salvar Tabela de Preço
        </button>
      </div>
    </form>
  </div>


</div> 